import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";
import Store from "..";
import { getTranslatedOptions } from "../../utils/helpers";

const initialState = {
  formFields: [],
};

export const updateDynamicFields = (fields: any) => async (dispatch: any) => {
  try {
    dispatch(updateFormFields(fields));
  } catch (e) {
    console.log("Search surveys", e);
  }
};

export const getFormFieldOptions = (id: any) => async (dispatch: any) => {
  try {
    const result = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/formfields/${id}/options`
    );
    if (result.data) {
      return getTranslatedOptions(result.data.result);
    }
  } catch (e) {
    console.log("Get form field options", e);
  }
};

const formReducer = createSlice({
  name: "forms",
  initialState,
  reducers: {
    updateFormFields(state, action: PayloadAction<any>) {
      state.formFields = action.payload;
    },
  },
});

export const { updateFormFields } = formReducer.actions;

export default formReducer.reducer;
